import BaseService from './BaseService'
import { IManufacturer } from 'src/interfaces/manufacturer'

const defaultUploadId = process.env.REACT_APP_DEFAULT_UPLOAD_ID

class ManufacturerService extends BaseService {
  constructor() {
    super('manufacturer')
  }

  create(manufacturer: IManufacturer): Promise<string> {
    const formData = new FormData()
    formData.append('upload_id', defaultUploadId) // default

    Object.keys(manufacturer).forEach((key) => {
      formData.append(key, manufacturer[key])
    })

    return new Promise((resolve, reject) => {
      try {
        this.http.post('manufacturer/create', formData).then(({ data }) => {
          if (data.code === 200) {
            this.cache.reset()
            resolve(data.data)
          } else reject({ message: data.message })
        })
      } catch (error) {
        reject({ message: 'An unexpected error occured!' })
        throw error
      }
    })
  }
 
  topByBuyer(buyerId: string): Promise<IManufacturer[]> {
    const formData = new FormData()
    formData.append('buyer_id', buyerId)

    return new Promise((resolve, reject) => {
      const cacheKey = `manufacturers_top_${buyerId}`
      const cachedData = this.cache.get(cacheKey)
      if (cachedData && false) {
        resolve(cachedData)
      } else {
        try {
          this.http
            .post(`manufacturer/top_by_buyer`, formData)
            .then(( data ) => {
              if (data.code === 200) {
                this.cache.set(cacheKey, data.data)
                resolve(data.data)
              } else reject({ message: data.message })
            })
        } catch (error) {
          reject({ message: 'An unexpected error occured!' })
          throw error
        }
      }
    })
  }
  
  fetchAvailable(locationId: string, page: number, limit: number): Promise<IManufacturer[] | IManufacturerPagedData> {
    const formData = new FormData()
    formData.append('location_id', locationId)
    formData.append('page', `${page}`)
    formData.append('limit', `${limit}`)

    if(page < 1) {
      return this.fetchAllAvailable(locationId)
    }

    return new Promise((resolve, reject) => {
      const cacheKey = `manufacturers_available_${locationId}_${page}_${limit}`
      const cachedData = this.cache.get(cacheKey)
      if (cachedData) {
        resolve(cachedData)
      } else {
        try {
          this.http
            .post(`manufacturer/read_available`, formData)
            .then(({ data }) => {
              if (data.code === 200) {
                this.cache.set(cacheKey, data.data)
                resolve(data.data)
              } else reject({ message: data.message })
            })
        } catch (error) {
          reject({ message: 'An unexpected error occured!' })
          throw error
        }
      }
    })
  }

  fetchAllAvailable(locationId: string): Promise<IManufacturer[]> {
    const formData = new FormData()
    formData.append('location_id', locationId)
    formData.append('page', '0')
    formData.append('limit', '0')

    return new Promise((resolve, reject) => {
      const cacheKey = `manufacturers_available`
      const cachedData = this.cache.get(cacheKey)
      if (cachedData && false) {
        resolve(cachedData)
      } else {
        try {
          this.http
            .post(`manufacturer/read_available`, formData)
            .then(( data ) => {
              if (data.code === 200) {
                // this.cache.set(cacheKey, data.data)
                resolve(data.data)
              } else reject({ message: data.message })
            })
        } catch (error) {
          reject({ message: 'An unexpected error occured!' })
          throw error
        }
      }
    })
  }
 
}

export default ManufacturerService
